import * as actionTypes from "./page-filter.actionTypes";

const initialState = {
  filter: [],
};

export default (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.SET_FILTER: {
      return { ...state, filter: action.payload };
    }

    case actionTypes.RESET: {
      return { ...initialState };
    }

    default:
      return state;
  }
};
